import { ReviewMetrics } from './model';

export enum REVIEWS_ACTIONS {
  GET_REVIEWS = 'GET_REVIEWS',
  INSERT_NEW_REVIEW = 'INSERT_NEW_REVIEW',
  FECTH_METRICS = 'FECTH_METRICS',
  CHECK_PENDING_REVIEWS = 'CHECK_PENDING_REVIEWS',
}

export enum REVIEWS_LOADERS {
  FECTH_METRICS = 'FECTH_METRICS',
  INSERT_NEW_REVIEW = 'INSERT_NEW_REVIEW',
  GET_REVIEWS = 'GET_REVIEWS',
}

export function makeInitialMetrics(metrics: ReviewMetrics) {
  return metrics.reduce((acc, metric) => ({ ...acc, [metric._id]: 0 }), {});
}
